var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLotteryTypeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 116,
    viewBox: "0 0 261 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 90C81.3757 90 106 65.3757 106 35C106 21.7037 101.282 9.50941 93.4284 0H236.993C251.811 0 263.089 13.2963 260.671 27.9162L249.425 95.9162C247.508 107.502 237.49 116 225.746 116H24C10.7452 116 0 105.255 0 92V55.6301C8.16035 75.7837 27.92 90 51 90Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotteryTypeBg);
export default __webpack_public_path__ + "static/media/lottery_type_bg.7fa80da427c7185cc6aa7ffca1371aa3.svg";
export { ForwardRef as ReactComponent };